module.exports = __webpack_public_path__ + "img/alert-triangle-outline-red.0e8bdaa7.svg";